import * as NotificationConstants from "../constants/notifications";

export const SendNotificationActionCreator = (notification) => {
	return {
		type: NotificationConstants.NOTIFICATION_SEND_REQUESTED,
		notification: notification
	};
};